import React from 'react';
import styled from '@emotion/styled';
import { mq } from 'style/variables';
import sizes from 'style/sizes';
import colors from 'style/colors';
import { TextSet } from 'components/molecules/textSet';
import { ContentInner } from 'components/organisms/contentInner';
import { EnHeading } from 'components/atoms/enHeading';

type InfromationProps = {};

const Container = styled.div`
  background-color: ${colors.gray03};
  padding: ${sizes.margin[49]} 45px;
  ${mq.onlysp} {
    padding: 44px ${sizes.margin[32]};
    margin: 59px 0 0;
  }
`;

export const Information: React.FC<InfromationProps> = props => {
  return (
    <ContentInner size={'medium'}>
      <Container {...props}>
        <TextSet noMargin={true}>
          <EnHeading size={'middle'}>Information</EnHeading>
          {props.children}
        </TextSet>
      </Container>
    </ContentInner>
  );
};
